import { defineBlock, smartProps } from '@smartfire/js-block-engine';
import { EditableImg } from '@smartfire/components';

function ImageEvolved() {
    return <EditableImg smartProp={'image'} style={{ display: 'block' }} />;
}

export default defineBlock({
    Block: ImageEvolved,
    smartProps: {
        image: smartProps.image,
    },
    setup: {
        title: 'Standard Image',
        parent: ['smartfire/standard-block---standard-two-columns---standard-column'],
    },
});
